/* Doku: https://dixonandmoe.com/rellax/ */

const rellaxDefaultOptions = {
  wrapper: null,
  center: true,
};
const videoElements = $('.videos-full-wrap .video-wrap.active > video');
const rellaxDestroyBreapoint = 768;
let windowWidth = window.innerWidth;
let prevBreakpoint = '';
let curBreakpoint = '';
let breakpointChanged = false;

const rellaxHeroImageBg = '.banner-wrapper-media:not(.banner-media-video), .frame-listtype-hofmanntpl_jobdetail .background-wrapper';
const rellaxParallaxBg = '.content-main .background-wrapper[data-rellax-speed]';
const rellaxParallaxBgFooter = '.content-footer .background-wrapper[data-rellax-speed]';
const parallaxLogos = '.parallax-images > img';

function setBreakpoint() {
  breakpointChanged = false;
  prevBreakpoint = curBreakpoint;
  windowWidth = window.innerWidth;
  if (windowWidth >= 1900 && curBreakpoint !== 'xxxl') {
    curBreakpoint = 'xxxl';
    breakpointChanged = true;
  } else if (windowWidth >= 1400 && curBreakpoint !== 'xxl') {
    curBreakpoint = 'xxl';
    breakpointChanged = true;
  } else if (windowWidth >= 1200 && curBreakpoint !== 'xl') {
    curBreakpoint = 'xl';
    breakpointChanged = true;
  } else if (windowWidth >= 992 && curBreakpoint !== 'lg') {
    curBreakpoint = 'lg';
    breakpointChanged = true;
  } else if (windowWidth >= 768 && curBreakpoint !== 'md') {
    curBreakpoint = 'md';
    breakpointChanged = true;
  } else if (windowWidth >= 576 && curBreakpoint !== 'sm') {
    curBreakpoint = 'sm';
    breakpointChanged = true;
  } else if (windowWidth < 576 && curBreakpoint !== 'xs') {
    curBreakpoint = 'xs';
    breakpointChanged = true;
  }
  return true;
}

function checkVideosReady() {
  let ready = 0;

  if (videoElements.length > 0) {
    videoElements.each((i, e) => {
      if (e.readyState === 4) {
        ready = 1;
      } else if (e.readyState !== 4 && ready === 1) {
        ready = 0;
      }
    });
  } else {
    ready = 1;
  }

  return ready;
}

function refreshTimeout(obj, i) {
  $(obj.elems[0]).css('transform', '');
  setTimeout(() => {
    // eslint-disable-next-line no-use-before-define
    refreshRellax(obj, i);
  }, 1);
}

function refreshRellax(obj, i = 0) {
  const maxIterations = 5;
  i += 1;

  if (i > maxIterations) {
    $(obj.elems[0]).css('transform', '');
    obj.destroy();
    setTimeout(() => {
      obj.refresh();
    }, 5);
    return true;
  }

  if (rellaxDestroyBreapoint < windowWidth) {
    if (videoElements.length > 0) {
      if (checkVideosReady() === 1) {
        setTimeout(() => {
          refreshTimeout(obj, i);
        }, 5);
      } else {
        setTimeout(() => {
          refreshTimeout(obj, i);
        }, 50);
      }
    } else if ($('[data-map="g"]').length > 0) {
      setTimeout(() => {
        refreshTimeout(obj, i);
      }, 50);
    } else {
      setTimeout(() => {
        refreshTimeout(obj, i);
      }, 100);
    }
  } else {
    // destroy rellax for mobile
    obj.destroy();
  }
  return true;
}

function refreshAfterHofmannApi(obj, elm) {
  if ($('.col-wdf-list').length > 0 && $(elm).isBefore('.col-wdf-list') === false) {
    document.addEventListener('hofmannApi:onAfterRender', () => {
      obj.refresh();
    });
  }
}

// eslint-disable-next-line no-unused-vars
function initParallax(){
  if ($(rellaxParallaxBg).length > 0) {
    $(rellaxParallaxBg).each(function () {
      let rellaxObj = new Rellax(this, rellaxDefaultOptions);
      refreshRellax(rellaxObj);
      refreshAfterHofmannApi(rellaxObj, this);
    });
  }
  if ($(rellaxParallaxBgFooter).length > 0) {
    $(rellaxParallaxBgFooter).each(function () {
      let rellaxObj = new Rellax(this, rellaxDefaultOptions);
      refreshRellax(rellaxObj);
      refreshAfterHofmannApi(rellaxObj, this);
    });
  }
  if ($(rellaxHeroImageBg).length > 0) {
    $(rellaxHeroImageBg).each(function () {
      let rellaxObj = new Rellax(this, rellaxDefaultOptions);
      refreshRellax(rellaxObj);
      refreshAfterHofmannApi(rellaxObj, this);
    });
  }
  if ($(parallaxLogos).length > 0) {
    $(parallaxLogos).each(function () {
      let rellaxObj = new Rellax(this, rellaxDefaultOptions);
      refreshRellax(rellaxObj);
      refreshAfterHofmannApi(rellaxObj, this);
    });
  }
}

window.onresize = (e) => {
  setBreakpoint();
  if (breakpointChanged === true) {
    initParallax();
  }
};
